import moment from "moment";
const HubspotReflectionPoolHandler = {

    event: {
        
        test: function(data, component){
            console.log(component.$store.getters.user);
            return new Promise( (resolve, reject) => {
                if (data){
                    console.log("Hubspot Reflection Event Handling Test")
                    resolve(true)
                }
                else{
                    console.log("Hubspot Reflection Event Handling Reject")
                    reject(false)
                }
            });
        },
        
        parametrize: function(data=null, event_typ=null, component){
            //Integrated so login can create a full hubspot contact record
            // if (event_typ==="login" || event_typ==="profile_validated"){
            //     return {
            //         uid: data.id,
            //         email: data.email,
            //     }
            // }
            if (((event_typ==="login" || event_typ==="profile_validated")) || (event_typ==="registration" || event_typ==="user_profile_update")){
                return {
                    uid: data.id,
                    firstname: data.firstname,
                    lastname: data.lastname,
                    email: data.email,
                    hs_language: data.language=="fr" ? "french" : "english",
                    hcp_job_profession: data.hcp_job_profession!==undefined ? data.hcp_job_profession : "Physician",
                    hcp_specialty: data.specialty,
                    contact_type: data.type,
                    ctc_casl: data.casl_consent,
                    address: data.address,
                    city: data.city,
                    province: data.province,
                    country: data.country,
                    zip: data.postalcode,
                }
            }
            
            if (event_typ==="user_joined_program"){
                return {
                    uid: data.id,
                    firstname: data.firstname,
                    lastname: data.lastname,
                    email: data.email,
                    hs_language: data.language=="fr" ? "french" : "english",
                    hcp_job_profession: data.hcp_job_profession!==undefined ? data.hcp_job_profession : "Physician",
                    hcp_specialty: data.specialty,
                    contact_type: data.type,
                    ctc_casl: data.casl_consent,
                    address: data.address,
                    city: data.city,
                    province: data.province,
                    country: data.country,
                    zip: data.postalcode,
                    program: data.program,
                    program_id: data.program_id
                }
            }
            
            if (event_typ==="program_step_state_progress"){
                return {
                    uid: data.id,
                    email: data.email,
                    program: data.program,
                    program_id: data.program_id,
                    step: data.step,
                    completed_qty: data.completed_qty
                }
            }
            
            if (event_typ==="user_completed_program"){
                return {
                    uid: data.id,
                    email: data.email,
                    program: data.program,
                    program_id: data.program_id
                }                
            }
            
            return {}
        },
        
        /*
         * @data Object
         */
        addFeed: function(data=null, event_typ=null, component=null){
            let self = component
            let that = this
            new Promise((resolve, reject)=>{
                let action = 'hubspot_reflection_pool_handler';
                let call = 'addFeed';
                let followup_event_typ = null
                let followup_data = null
                if (event_typ==='registration_user_joined_program'){
                    event_typ = 'registration'
                    followup_event_typ = "user_joined_program"
                    followup_data = {...data}
                }
                if(self.$sendRequest){
                    self.$sendRequest({
                        action: action,
                        call: call,
                        autoload: true,
                        event_typ: event_typ,
                        params: JSON.stringify({"user":JSON.stringify(this.parametrize(data, event_typ, self)), "event_datetime":moment().format("YYYY-MM-DD HH:mm:ss")})
                    }).then(function(response){
                        if (response.data[action][call].result){
                            if (followup_event_typ!==null){
                                self.$sendRequest({
                                    action: action,
                                    call: call,
                                    autoload: true,
                                    event_typ: followup_event_typ,
                                    params: JSON.stringify({"user":JSON.stringify(that.parametrize(followup_data, followup_event_typ, self)), "event_datetime":moment().format("YYYY-MM-DD HH:mm:ss")})
                                }).then(function(response){
                                    if (response.data[action][call].result){
                                        resolve()
                                    }
                                    else {
                                        reject()
                                    }
                                })
                            }
                            resolve()
                        }else{
                            reject();
                        }
                    },function(){
                        reject();
                    })
                }else{
                    setTimeout(function(){
                        resolve();
                    },500)
                }                        
            })
        }
    }
};

export default HubspotReflectionPoolHandler
